import React from 'react';

import styled from 'styled-components';

import { NwCancelButton, NwSaveButton } from '@components/Gui/NwButton';

const BarRoot = styled.div`
    position: fixed;
    width: ${(props) => (props.$width != null ? props.$width : '60vw')};
    min-width: ${(props) => (props.$minWidth != null ? props.$minWidth : '980px')};
    bottom: 0;
    right: 0;
    background-color: rgba(255, 255, 255, 0.92);
    backdrop-filter: blur(6px);
    padding: 1rem 3rem 2rem 3rem;
    border-top: ${(props) => props.theme.DefaultBorder};
    display: flex;
    justify-content: space-between;
    align-items: center;
    z-index: ${(props) => props.$zIndex ?? 1000};
`;

/**
 * Fixed viewport bar: cancel (left) and save (right), or custom nodes.
 * Legacy form usage: omit `left` / `right` and pass `onCancel`, `isSubmitting`, `isValid` (save = submit).
 *
 * @param {object} props
 * @param {import('react').ReactNode} [props.left]
 * @param {import('react').ReactNode} [props.right]
 * @param {() => void} [props.onCancel]
 * @param {boolean} [props.isSubmitting]
 * @param {boolean} [props.isValid]
 * @param {string} [props.width]
 * @param {string} [props.minWidth]
 * @param {number} [props.zIndex]
 */
const NwFixedCancelAndSaveBar = ({ left, right, onCancel, isSubmitting, isValid, width, minWidth, zIndex }) => {
    const resolvedLeft = left ?? <NwCancelButton disabled={isSubmitting} onClick={onCancel} />;
    const resolvedRight =
        right ?? <NwSaveButton htmlType="submit" disabled={!isValid} loading={isSubmitting} />;

    return (
        <BarRoot $width={width} $minWidth={minWidth} $zIndex={zIndex}>
            {resolvedLeft}
            {resolvedRight}
        </BarRoot>
    );
};

export default NwFixedCancelAndSaveBar;
